// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"f1cb7b87","506":"bd00b67f","760":"c04f560d","800":"dc938a01"}[chunkId] + ".chunk.js";
};